export const reportsInitialState = {
  incomes: {
    incomeTotal: 0,
    incomesData: {},
  },
  expenses: {
    expenseTotal: 0,
    expensesData: {},
  },
};